import { CerberusInputHcs } from '@hcs/types';
import { formatFullAddress } from '@hcs/utils';

export const reactKeyFromCerberusInput = (
  cerberusInput: CerberusInputHcs | undefined
) =>
  cerberusInput?.hcAddressId ||
  cerberusInput?.slug ||
  formatFullAddress(cerberusInput);
